import React from 'react';

import { CallCentreResetPasswordThankyouView } from './CallCentreResetPasswordThankyouView';
import { navigation } from '@origin-digital/reporting-client';

interface CallCentreResetPasswordThankyouPageProps {
  nextAction: () => void;
}

const CallCentreResetPasswordThankyouPage: React.FC<CallCentreResetPasswordThankyouPageProps> = ({
  nextAction,
}) => {
  React.useEffect(
    () =>
      navigation('screen', {
        currentUri: '',
        friendlyUri: 'originenergy:my-account:auth:forgot-password-reset-manual-success',
      }),
    [],
  );
  return <CallCentreResetPasswordThankyouView nextAction={nextAction} />;
};

export { CallCentreResetPasswordThankyouPage };
